import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <div>
        <h1>課程與學員管理系統</h1>
      </div>
    );
  }
}